import { v4 as uuid } from 'uuid';
import { USER_DIALOG_ACTION_TYPES } from '../../constants/userDialog.constants';

export const showEditZoneDialog = ({ requestId = uuid(), ...options } = {}) => ({
  type: USER_DIALOG_ACTION_TYPES.SHOW_EDIT_ZONE_DIALOG,
  payload: { ...options, requestId },
});

export const hideEditZoneDialog = (requestId) => ({
  type: USER_DIALOG_ACTION_TYPES.HIDE_EDIT_ZONE_DIALOG,
  payload: { requestId },
});

export const editZoneDialogSaved = (editZone, requestId) => ({
  type: USER_DIALOG_ACTION_TYPES.EDIT_ZONE_DIALOG_SAVED,
  payload: { editZone, requestId },
});
